"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowRightIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ArrowRightIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M14.9678 8C14.974 8 15.8837 8.89878 16.9895 9.99728C18.0953 11.0958 19 11.997 19 12C19 12.0108 14.9787 16 14.9679 16C14.9618 16 14.7589 15.8033 14.5169 15.5628L14.0769 15.1256L15.6556 13.5574L16.5522 12.6667L6.52137 12.6667V11.3333L16.5742 11.3333L15.6612 10.4264L14.0882 8.8637L14.5224 8.43185C14.7612 8.19433 14.9616 8 14.9678 8Z" }))); };
exports.ArrowRightIcon = ArrowRightIcon;
